import { useNavigate } from 'react-router-dom';

export const useOpenEditor = (groupId: number) => {
  const navigate = useNavigate();

  const edit = () => {
    // Изменить группу
    navigate(`/clients/groups/edit/${groupId}`);
  };

  return {
    edit,
  };
};
